module.exports = function getResource(label, vars = []) {
    const resources = {
        askToCancel: 'Êtes-vous sûr de vouloir annuler cette réservation?',
        yes: 'Oui',
        no: 'Non'
    };

    return resources[label];
};
